import '../vendor/fontawesome-pro/js/fontawesome';
import '../vendor/fontawesome-pro/js/light';
import '../vendor/fontawesome-pro/js/duotone';
import '../vendor/fontawesome-pro/js/brands';

import { Turbo } from '@hotwired/turbo-rails';
import * as ActiveStorage from '@rails/activestorage';
import '@rails/actiontext';
import 'chartkick/chart.js';
import LocalTime from 'local-time';
import 'trix';
import '../controllers';

import.meta.glob('../stream_actions/**/*.js', { eager: true });

Turbo.start();
window.Turbo = Turbo;
ActiveStorage.start();
LocalTime.start();
